import { useLeaveRequestPreview } from '@/services/availability/useLeaveRequestPreview';
import { strings } from '@/services/translation/strings';
import { LeaveAllowanceCheck } from '@/shared/leave/LeaveAllowanceCheck';
import { LeaveOverlapNotice } from '@/shared/leave/LeaveOverlapNotice';
import { FC, useEffect } from 'react';
import essStrings from '../../ess.translations';

interface MyLeavePreviewProps {
  availabilityType: string;
  start: Date;
  end: Date;
  onLoaded: (exceeded: boolean, hasOverlap: boolean) => void;
}

export const MyLeavePreview: FC<MyLeavePreviewProps> = ({ availabilityType, start, end, onLoaded }) => {
  const {
    hasPreview,
    checks,
    daysToTake,
    fetching: previewLoading,
    exceeded,
    overlappingDates,
    hasOverlap
  } = useLeaveRequestPreview(availabilityType, start, end);

  useEffect(() => {
    if (!previewLoading) {
      onLoaded(exceeded, hasOverlap);
    }
  }, [previewLoading, exceeded, hasOverlap, onLoaded]);

  if (!hasPreview) {
    return null;
  }

  return (
    <>
      {hasOverlap && <LeaveOverlapNotice dates={overlappingDates} title={essStrings.myLeave.overlapTitle} />}

      {hasPreview && daysToTake > 0 && (
        <LeaveAllowanceCheck
          checks={checks}
          daysToTake={daysToTake}
          messages={{
            daysToTake: strings.common.daysToTake,
            exceededSeverity: 'warning',
            exceeded: (c, label) => essStrings.myLeave.exceeded(label, c.requested, c.allowance - c.used),
            remaining: (c, label) => essStrings.myLeave.remainingAfter(c.remaining, label)
          }}
        />
      )}
    </>
  );
};
